/**
 * Vehicle entity — transport.Vehicle (xsite/transport/models.py).
 */

import { createResourceApi } from '../shared/resourceApi';
import { createResourceHooks } from '../shared/createResourceHooks';
import type { Project } from './project';

export interface VehicleProjectStatistics {
  total_projects: number;
  active_projects: number;
  completed_projects: number;
}

export interface Vehicle {
  id: number;
  name: string;
  category?: number | null;
  category_name?: string | null;
  description?: string;
  licence_plate?: string;
  available: boolean;
  next_technical_check_date?: string | null;
  technical_check_status?: string;
  days_until_technical_check?: number | null;
  km_tariff_amount?: number | string | null;
  flat_tariff_amount?: number | string | null;
  // Detail-only: nested by VehicleDetailSerializer
  active_projects?: Project[];
  project_statistics?: VehicleProjectStatistics;
}

export const vehicleApi = createResourceApi<Vehicle>('transport/api/vehicles');

export const {
  keys: vehicleKeys,
  useList: useVehicles,
  useDetail: useVehicle,
  useCreate: useCreateVehicle,
  useUpdate: useUpdateVehicle,
  useRemove: useDeleteVehicle,
} = createResourceHooks(vehicleApi, {
  name: 'vehicles',
  model: 'transport.vehicle',
  detailRelatedModels: ['projects.project', 'projects.projectvehicle'],
});
